import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useWsSubscription } from '@shared/ws';
import { useSessionStore } from '@entities/session';
import { chatKeys, type InboxEvent } from '@entities/chat';
import {
  notificationKeys,
  parsePushPayload,
  type NotificationPushEvent,
} from '@entities/notification';

export function GlobalInbox() {
  const status = useSessionStore((s) => s.status);
  const qc = useQueryClient();

  // §11 — new chat messages while offline / in another conversation.
  useWsSubscription<InboxEvent>(
    status === 'authenticated' ? '/user/queue/inbox' : null,
    useCallback(() => {
      void qc.invalidateQueries({ queryKey: chatKeys.unread() });
      void qc.invalidateQueries({ queryKey: chatKeys.conversations() });
    }, [qc]),
  );

  // §13.3 — server-side push of newly created notifications.
  useWsSubscription<NotificationPushEvent>(
    status === 'authenticated' ? '/user/queue/notifications' : null,
    useCallback(
      (event) => {
        // Touch payload to keep the helper alive in builds where dev consumers
        // may extend this branch with snackbar deep-links later.
        void parsePushPayload(event.payloadJson);
        void qc.invalidateQueries({ queryKey: notificationKeys.all });
      },
      [qc],
    ),
  );

  return null;
}
